// extracted by mini-css-extract-plugin
module.exports = {"root":"Tab_root__r_bEW","active":"Tab_active__opt3t","background":"Tab_background__ZJD83","underline":"Tab_underline__MMU1O"};